import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserInfoComponent} from './components/user-info/user-info.component';
import {RoleModule} from '@core/modules/role/role.module';

@NgModule({
  declarations: [
    UserInfoComponent
  ],
  exports: [
    UserInfoComponent
  ],
    imports: [
        CommonModule,
        RoleModule
    ]
})
export class UserModule { }
